import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import type { BackofficeUserType } from '@/backoffice/config/theme';
import { getNavItems } from '@/backoffice/config/navigation';

/** Détermine le rôle back-office depuis l'URL courante. */
export function useBackofficeRole(): BackofficeUserType {
  const { pathname } = useLocation();
  if (pathname.includes('/super-admin')) return 'super_admin';
  if (pathname.includes('/dashboard/admin')) return 'admin';
  if (pathname.includes('/livreur-pro')) return 'pro_driver';
  if (pathname.includes('/dashboard/livreur')) return 'community_driver';
  return 'client';
}

/** Retourne le chemin actif le plus spécifique parmi les items de navigation. */
export function useActiveNavPath(userType: BackofficeUserType): string {
  const { pathname } = useLocation();
  const navItems = getNavItems(userType);

  return useMemo(() => {
    const sorted = [...navItems].sort((a, b) => b.path.length - a.path.length);
    const match = sorted.find(
      (item) => pathname === item.path || pathname.startsWith(`${item.path}/`),
    );
    return match?.path ?? '';
  }, [pathname, navItems]);
}
